import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container py-10 mx-auto" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "font-bold text-xl" }

import {Button} from "@/components/ui/button";
  import {Plus} from "lucide-vue-next";
  import CategoriesEditForm from "@/components/tables/categories/CategoriesEditForm.vue";
  import {onMounted, ref, watch} from "vue";
  import axios from "axios";
  import TablesService from "@/services/tables/tables.service";
  import {toast} from "@/utils/utils";
  import {i18n} from "@/utils/i18n";
  import useEventsBus from "@/utils/eventBus";
  import {Category} from "@/models/tables/category.interface";
  import CategoriesDataTableDropDown from "@/components/tables/categories/CategoriesDataTableDropDown.vue";

  const entity = 'categories';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'CategoriesTree',
  setup(__props) {

  const isAddDialogOpen = ref(false);
  const categories = ref<Category[]>([]);
  const flattenedCategories = ref([]);
  const { bus } = useEventsBus();

  const fetchCategories = async () => {
    const res = await axios.get(process.env.VUE_APP_BASE_API_URL + 'categories/tree', {
      headers: {
        Authorization: process.env.VUE_APP_API_KEY
      }
    });
    categories.value = res.data;
    flattenedCategories.value = flattenCategories(res.data);
  };

  function flattenCategories(categories: any, level = 0): any {
    let result = [];
    for (const category of categories) {
      let flatCategory = {
        ...category,
        indentedName: `${'. '.repeat(level)}${category.name}`,
        level: level
      };
      result.push(flatCategory);
      if (category.children && category.children.length) {
        result = result.concat(flattenCategories(category.children, level + 1));
      }
    }
    return result;
  }

  const setIsAddDialogOpen = (value: boolean) => {
    isAddDialogOpen.value = value;
  };

  onMounted(() => {
    fetchCategories();
  });

  watch(() => bus.value.get('delete_'+entity), async (value) => {
    await TablesService.deleteRecord(value, entity);
    await fetchCategories();
    toast.success(i18n.global.t('toast.delete_success'));
  })

  watch(() => bus.value.get('update_'+entity), async () => {
    await fetchCategories();
    setIsAddDialogOpen(false);
    toast.success(i18n.global.t('toast.edit_success'));
  })

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_treeview = _resolveComponent("v-treeview")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, { class: "p-0 m-0" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('table.categories_list')), 1),
          _createVNode(_unref(Button), {
            color: "primary",
            class: "ml-auto",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setIsAddDialogOpen(true)))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Plus), { class: "mr-2 h-5 w-5" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('table.add')), 1)
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_v_treeview, {
          items: categories.value,
          activatable: ""
        }, {
          prepend: _withCtx(() => [
            _createElementVNode("label", null, [
              _createVNode(_component_v_icon, { class: "mr-2" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString('mdi-folder'))
                ]),
                _: 1
              })
            ])
          ]),
          append: _withCtx(({ item }) => [
            _createVNode(CategoriesDataTableDropDown, {
              entity: entity,
              object: item,
              parents: flattenedCategories.value
            }, null, 8, ["object", "parents"])
          ]),
          _: 1
        }, 8, ["items"]),
        _createVNode(CategoriesEditForm, {
          "set-open": setIsAddDialogOpen,
          entity: entity,
          open: isAddDialogOpen.value,
          object: "",
          parents: flattenedCategories.value
        }, null, 8, ["open", "parents"])
      ]),
      _: 1
    })
  ]))
}
}

})